//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.form`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 50%;
    min-width: 300px;
`;
export const Content = styled.section`
    border: 1px dashed var(--light-gray-4);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 32px;
    user-select: none;
    transition: 0.35s;
    &.drag-enter {
        background-color: var(--light-3);
    }
    & > h3 {
        font-size: 16px;
        color: var(--dark-4);
        margin: 0;
    }
    &.error {
        border-color: var(--red-3);
    }
`;
export const BeforeUpload = styled.section`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    transition: 0.35s;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
        background-color: #0000000a;
    }
    & > h5 {
        color: var(--purple-2);
        font-size: 14px;
        margin: 0;
    }
    & > svg {
        fill: var(--purple-2);
    }
`;
export const Detail = styled.p`
    color: var(--light-gray-5);
    text-align: center;
    font-size: 16px;
`;
export const File = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 60%;
    & > div {
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 6px;
        background-color: var(--purple-2);
        padding: 6px 10px;
        border-radius: 4px;
        & * {
            color: var(--light-1);
        }
        & span, & strong {
            font-size: 14px;
        }
        & span {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        & strong {
            width: max-content;
        }

    }
    & span[data-role="icon"] {
        width: 50px !important;
        display: grid;
        place-items: center;
        & svg {
            fill: var(--light-1);
        }
    }
    & > span {
        padding: 2px;
        border-radius: 3px;
        transition: 0.35s;
        cursor: pointer;
        &:hover {
            background-color: #00000010;
        }
    }
    @media (max-width: 1100px) {
        width: 90%;
    }
`;